import { gql } from '../../../../../types/__codegen__/sanity';

export const GET_TAX_RATES = gql(`
  query getTaxRates {
    allRate(where: { type: { eq: "medicare-levy-surcharge" } }, limit: 2, sort: { _createdAt: ASC }) {
      _id
      name
      title
      summary: summaryRaw
      type
      brackets {
        name
        bracketType {
          name
          title
        }
        tiers {
          name
          tierMinimum
          tierMaximum
          rate
        }
      }
      release {
        ...ReleaseFields
      }
    }
  }
`);
